import { Upload } from "antd";
import type { FC, PropsWithChildren } from "react";
import type { UploadProps } from "antd/lib";

export const VcfUploadWrapper: FC<PropsWithChildren<UploadProps>> = ({ children, ...props }) => {
  return (
    <Upload accept=".vcf" showUploadList={false} {...props}>
      {children}
    </Upload>
  );
};
